import SelectFilter from '../templates/SearchFilter';
import { DOCTOR_TITLE } from '@vindr/services/constants/study.constant';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const AcademicRank = ({ title, placeholder, value, onChange, width }: SelectFilter) => {
  const { t } = useTranslation('Vindoc');
  title = ['boolean', 'string'].includes(typeof title) ? title : t('Academic Rank');
  placeholder = placeholder || t('Select Academic Rank');

  const options = useMemo(
    () => DOCTOR_TITLE?.map((item) => ({ value: item, label: t(item) })),
    [t]
  );

  return <SelectFilter {...{ width, value, title, placeholder, onChange, options }} />;
};

export default memo(AcademicRank);
